
import { measureHelper } from './helper/measureHelper'
import { defines, CanvasInfo } from '../base/index';
import { ThreeView } from "./index";
import { ScreenPositionUtil } from '../../../digifie/utils';

const Direction = {
    top: 0,
    bottom: 1,
    right: 2,
    left: 3
} as const;

export class MeasureManager {

    public measures: measureHelper[] = [];

    constructor() {}

    public createMeasure(object: THREE.Object3D) {
        const wcmgr = ThreeView.get().wcItemmgr;
        const scene = ThreeView.get().wcScene.me;

        //メジャー index = 0: 上, 1: 下, 2: 右, 3: 左
        const helper1 = new measureHelper(object, [wcmgr.houseObjects], Direction.top);
        const helper2 = new measureHelper(object, [wcmgr.houseObjects], Direction.bottom);
        const helper3 = new measureHelper(object, [wcmgr.houseObjects], Direction.right);
        const helper4 = new measureHelper(object, [wcmgr.houseObjects], Direction.left);
        this.measures.push( ...[ helper1, helper2, helper3, helper4 ] );
        scene.add(...[ helper1, helper2, helper3, helper4 ]);

        this.measures.forEach((measure: measureHelper, index: number) => {
            this.createDiv(measure, index);
        });
    }

    // divタグの作成
    private createDiv = (measure: measureHelper, index: number) =>  {
        const div = document.createElement('div');
        div.id = `3DMeasure${ index }`;
        div.style.position = 'absolute';

        const elm = document.getElementById('webcad3dView');
        elm.appendChild(div);
        div.style.visibility = 'hidden';

        if(measure.distance != -Infinity) {
            this.measurePosition(index, measure,div);
        }
    }

    public removeMeasure() {
        if(this.measures.length == 0) return;

        const scene = ThreeView.get().wcScene.me;
        this.measures.forEach((measure: measureHelper, index: number) => {
            scene.remove(measure);
            measure.dispose();
            const elm = document.getElementById(`3DMeasure${ index }`);
            if (elm) {
                elm.remove();
            }
        });
        this.measures = [];
    }

    // private calcPosition(screenPosition) {
    //     const element1 = document.getElementById('webcad3dView');
    //     const element2 = ThreeView.get().wcRenderer.me.domElement;

    //     const rect1 = element1.getBoundingClientRect();
    //     const rect2 = element2.getBoundingClientRect();

    //     const x = screenPosition.x - (rect2.x - rect1.x) + rect1.x;
    //     const y = screenPosition.y - (rect2.y - rect1.y) + rect1.y;
    //     return {x: x, y: y};
    // }

    // three.jsのviewでのスクリーン座標
    private screenPosition(pos: THREE.Vector3) {
        const size = CanvasInfo.get().size;

        const camera = <THREE.PerspectiveCamera>ThreeView.get().cameras.camera.me;
        // スクリーン座標を取得する
        const projection = pos.project(camera);

        const sx = (size.x / 2) * (+projection.x + 1.0);
        const sy = (size.y / 2) * (-projection.y + 1.0);
        return { x: sx, y: sy };
    }

    private measurePosition(index: number, measure: measureHelper, div: HTMLElement) {
        div.style.visibility = 'visible';
        const dist = (measure.distance * 1000).toFixed();
        div.innerHTML = `${dist}mm`;
        this.setSunpouPosition(measure, index);

        // const pos = this.calcPosition(this.screenPosition(measure.point.clone()));
        const pos = this.screenPosition(measure.point.clone());

        div.style.left = `8px`;
        if (index == Direction.top || index == Direction.bottom) div.style.top = `0px`;
        if (index == Direction.right || index == Direction.left) div.style.top = `5px`;
        div.style.backgroundColor = 'rgba(255, 255, 255, 0.5)'

        const layer = `L${ThreeView.get().wcCameras.floor}`;
        const size = CanvasInfo.get().size;
        const objects = ThreeView.get().wcItemmgr.floorsObjects.getObjects(layer);
        const camera = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
        const position = new ScreenPositionUtil().ScreenCoordinates(size, ThreeView.get().ItemDragManager.selectObj, camera.me, objects);
        if (position.x == -100 && position.y == -100) div.style.transform = `translate(${position.x}px, ${position.y}px)`;
        else div.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
    }

    public update() {
        this.measures.forEach((measure: measureHelper, index: number) => {
            measure.update();
            if(measure.distance == -Infinity) return;

            const div = document.getElementById(`3DMeasure${ index }`);
            this.measurePosition(index, measure, div);
        });
    }

    public updateMeasure() {
        this.measures.forEach((measure: measureHelper, index: number) => {
            const div = document.getElementById(`3DMeasure${ index }`);
            if(div == null) return;

            div.style.visibility = 'hidden';

            measure.update();
            if(measure.distance == -Infinity) return;
            this.measurePosition(index, measure, div);
        });
    }

    // 距離測定の位置
    private setSunpouPosition = (measure: measureHelper, index: number) => {
        if (index == Direction.top) measure.point.y += measure.distance / 3;
        if (index == Direction.bottom) measure.point.y -= measure.distance / 3;
        if (index == Direction.right || index == Direction.left) {
            if (measure.distance / 3 < 0.5) measure.point.add(measure.direction.clone().multiplyScalar(measure.distance / 3));
            else measure.point.add(measure.direction.clone().multiplyScalar(0.5));
        }
    }

    public visibleMesure(cameraIndex: number): void {
        if (this.measures.length < 1) return;
        this.measures.forEach((measure: measureHelper, num: number) => {
            const div = document.getElementById(`3DMeasure${num}`);
            if ( div != null && cameraIndex == defines.CameraDefs.orbitCamNo ) div.style.visibility = 'hidden';
            if ( div != null && cameraIndex == defines.CameraDefs.wlkthCamNo ) div.style.visibility = 'visible';
        });
        if ( this.measures && cameraIndex == defines.CameraDefs.orbitCamNo ) this.measures.forEach(mesure => mesure.visible = false);
        if ( this.measures && cameraIndex == defines.CameraDefs.wlkthCamNo ) this.measures.forEach(mesure => mesure.visible = true);
    }

    public changeTagetObject(object: THREE.Object3D) {
        this.measures.forEach((measure: measureHelper) => {
            measure.setObj(object);
        });
    }
}
